import itLocale from 'date-fns/locale/it';
import enLocale from 'date-fns/locale/en-US';
/**Js file containing all usable Dates functions **/

const TODAY = new Date();
const DAY_IN_MS = 24 * 60 * 60 * 1000; //24 hours in milliseconds

const getLang = () => {
  const lang = navigator.language;
  if (!lang || lang.startsWith('it')) return 'it-IT';
  return 'en-US';
};

export const culture = getLang();
export const locales = {
  'it-IT': itLocale,
  'en-US': enLocale,
};
export const options = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

//compares 2 provided dates
//useful for conditions
export const compareDates = (date1, date2, compareOperator = 'equal') => {
  if (compareOperator === 'bigger') return date1.getTime() > date2.getTime();

  if (compareOperator === 'smaller') return date1.getTime() < date2.getTime();

  return (
    date1?.getDate() === date2?.getDate() &&
    date1?.getMonth() === date2?.getMonth() &&
    date1?.getYear() === date2?.getYear()
  );
};

//if there is a providedDate creates a new Date with it otherwise creates a new Date
//useful for incoming data from api when you don't know if is null or not
export const createNewDate = (providedDate) => {
  let date;
  if (providedDate) date = new Date(providedDate);
  else date = new Date();
  return date;
};

/* //formate provided date hour in to send it to database
export const formatToCorrectTime = (providedDate) =>
  new Date(providedDate.getTime() + new Date().getTimezoneOffset() * 60000);
 */
//returns the age for a provided birthdate
export const getAge = (birthDate) => {
  // birthday is a date
  const ageDifMs = Date.now() - birthDate.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

//add 0 to time string
export const addZero = (providedTime) => {
  const hours = providedTime.getHours();
  const minutes = providedTime.getMinutes();

  return `${`0${hours}`.slice(-2)}:${`0${minutes}`.slice(-2)}`;
};

export const calculateDaysBetweenRange = (dateA, dateB) => {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(dateA.getFullYear(), dateA.getMonth(), dateA.getDate()); //milliseconds
  const utc2 = Date.UTC(dateB.getFullYear(), dateB.getMonth(), dateB.getDate()); //milliseconds

  return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
};

export const addDays = (date, days) => {
  const result = date ? new Date(date) : new Date();
  result.setDate(result.getDate() + days);
  return result;
};

export const getMonday = (currentDate) => {
  const d = new Date(currentDate || new Date());
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
};

export const getFriday = (currentDate) => addDays(getMonday(currentDate), 4);
export const olderOrNewerThanDays = (date, daysNumber, method) => {
  const daysInMilliseconds = daysNumber * 24 * 60 * 60 * 1000; //days in milliseconds
  let calculatedDays = 0;

  if (method === 'older') {
    calculatedDays = date.getTime() - daysInMilliseconds; //older
    return calculatedDays > daysNumber;
  }
  calculatedDays = date.getTime() + daysInMilliseconds; //newer

  return calculatedDays < daysNumber;
};

export const roundToHalfHour = (providedTime) => {
  let hours = providedTime.getHours();
  let minutes = providedTime.getMinutes();

  hours = minutes >= 45 ? ++hours : hours; //round to next hour if minutes are more than 45
  minutes = (Math.round(minutes / 30) * 30) % 60; //round minutes to multiple of 30

  return { hours, minutes };
};

export const isAroundTime = (providedTime, offset) => {
  const timeInMilliseconds = providedTime.getTime();
  const offsetInMilliseconds = offset * 60 * 1000;
  const before = new Date().getTime() - offsetInMilliseconds;
  const after = new Date().getTime() + offsetInMilliseconds;

  if (timeInMilliseconds > before && timeInMilliseconds < after) {
    return true;
  }
  return false;
};

export const getPreviousDate = (providedDate) => {
  //accurate to millisecond previous date
  const currentDayInMilli = new Date(providedDate).getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  const previousDayInMilli = currentDayInMilli - oneDay;
  const previousDate = new Date(previousDayInMilli);

  return previousDate;
};

export const getNextDate = (providedDate) => {
  //accurate to millisecond previous date
  const currentDayInMilli = new Date(providedDate).getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  const nextDayInMilli = currentDayInMilli + oneDay;
  const nextDate = new Date(nextDayInMilli);

  return nextDate;
};

/**
 * Function accepts a date or a string and returns a formatted localeDateString:
 *
 * @param {[String, Date]} providedDate - Date or String. The date param that can be a string that will be parsed to a Date if possible.
 *
 * @returns {String}
 */

export const formatListItemDate = (providedDate, dateTime = false) => {
  const date = providedDate ? new Date(providedDate) : null;

  if (!date || isNaN(date.getTime())) return ''; //return empty string if invalid Date
  //shows both
  if (dateTime)
    return date.toLocaleDateString(culture, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

  if (TODAY.getTime() - date.getTime() > DAY_IN_MS)
    //complete date without time
    return date.toLocaleDateString(culture, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

  //only time
  return addZero(date);
};

export const addToDate = (providedDate, daysCount) => {
  const pastDate = new Date(providedDate);
  pastDate.setDate(pastDate.getDate() + daysCount);

  return pastDate;
};

export const dateInLastDays = (providedDate, daysCount) => {
  const today = new Date();
  const pastDate = new Date();
  pastDate.setDate(today.getDate() - daysCount); // Subtract N days from today

  return (
    providedDate.getTime() >= pastDate.getTime() &&
    providedDate.getTime() <= today.getTime()
  );
};

export const getTodayRange = () => {
  const today = new Date();
  return [today, today];
};

export const getYesterdayRange = () => {
  const today = new Date();
  const yesterday = today.setDate(today.getDate() - 1);
  return [yesterday, yesterday];
};

export const getThisWeekRange = () => {
  // Work week: Monday to Friday
  // (getDay() + 6) % 7 gives days elapsed since Monday (Mon=0 … Sun=6)
  const first = new Date();
  first.setDate(first.getDate() - ((first.getDay() + 6) % 7));
  const last = new Date();
  last.setDate(last.getDate() - ((last.getDay() + 6) % 7) + 4);
  return [first, last];
};

export const getLastWeekRange = () => {
  // Work week: last Monday to last Friday
  const first = new Date();
  first.setDate(first.getDate() - ((first.getDay() + 6) % 7) - 7);
  const last = new Date();
  last.setDate(last.getDate() - ((last.getDay() + 6) % 7) + 4 - 7);
  return [first, last];
};

export const getThisMonthRange = () => {
  const first = new Date();
  first.setFullYear(first.getFullYear(), first.getMonth(), 1);
  const last = new Date();
  last.setFullYear(last.getFullYear(), last.getMonth() + 1, 0);

  return [first, last];
};

export const getMonthRange = (monthNumber) => {
  const currentYear = new Date().getFullYear();
  // monthNumber is 1-12, but setMonth uses 0-11
  const monthIndex = monthNumber - 1;
  const first = new Date();
  first.setFullYear(currentYear, monthIndex, 1);
  const last = new Date();
  last.setFullYear(currentYear, monthIndex + 1, 0);

  return [first, last];
};

export const formatPayloadDate = (providedDate) => {
  if (!providedDate) return null;
  const date = new Date(providedDate);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
};
